import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, first, switchMap } from 'rxjs/operators';
import { isEmpty } from 'lodash';
import { Store } from '@ngrx/store';

import { ReportingPeriodsApiService } from 'projects/workspace/src/app/reporting-periods/services/reporting-periods-api.service';
import { selectReportingSettings } from 'projects/workspace/src/app/store/selectors/shared.selectors';
import { AdministrationsApiService } from 'projects/workspace/src/app/administration/services/administrations-api.service';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';
import { CompanyProfile } from 'projects/workspace/src/app/administration/models/company-profile.model';
import { selectCompanyProfile } from 'projects/workspace/src/app/administration/store/selectors';
import { ReportingPeriodsPreferencesModel } from 'projects/workspace/src/app/reporting-periods/models';

@Injectable({
  providedIn: 'root'
})
export class ReportingPreferencesGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly administrationsApiService: AdministrationsApiService,
    private readonly reportingPeriodsApiService: ReportingPeriodsApiService,
    private readonly store: Store<AppState>
  ) {}

  canActivate(): Observable<boolean> | boolean {
    return this.store.select(selectCompanyProfile)
      .pipe(
        first(),
        switchMap((companyProfile: CompanyProfile) => {
          return isEmpty(companyProfile)
            ? this.administrationsApiService.getCompanyProfile()
            : of(companyProfile);
        }),
        switchMap(() => this.store.select(selectReportingSettings)),
        switchMap((settings: ReportingPeriodsPreferencesModel) => {
          return settings && settings.id
            ? of(true)
            : this.reportingPeriodsApiService.getReportingPeriodsPreferences();
        }),
        catchError(() => {
          this.router.navigate(['/']);
          return of(false);
        }),
        switchMap(() => of(true))
      );
  }

}

